import { render, staticRenderFns } from "./EventFormDialog.vue?vue&type=template&id=4e40c3af&scoped=true"
import script from "./EventFormDialog.vue?vue&type=script&lang=js"
export * from "./EventFormDialog.vue?vue&type=script&lang=js"
import style0 from "./EventFormDialog.vue?vue&type=style&index=0&id=4e40c3af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e40c3af",
  null
  
)

export default component.exports